import React, { useEffect, useState } from 'react';
import './PageLoader.css';
import lod from '../../../assets/images/pentalens-loader.png'
import { AbstructVar } from '../general-component/abstruct-component/AbstructVar';
import { loadMainPermission } from '../../../store/Actions/ActionRolesAndPermissions';
import { useSelectorCustom } from '../general-component/abstruct-component/useSelectorCustom';

function PageLoader({setIsLoading,isLoading}) {
    const {dispatch} = AbstructVar()
    const {mainPermission,loadingMainPermission} = useSelectorCustom()
    const [statusLoading,setStatusLoading] = useState()
    useEffect(()=>{
        dispatch(loadMainPermission(setStatusLoading))
    },[])
    useEffect(()=>{
        if(!loadingMainPermission && statusLoading){
            console.log(mainPermission)
            setIsLoading(false)
        }
        if(!statusLoading){
            setIsLoading(false)
        }
    },[loadingMainPermission])
    return (
        <section className="loader">
            <img src={lod} />
        </section>
    );
}

export default PageLoader;